class Puzzle {
  constructor() {
    this.$puzzle = document.querySelector('.js-puzzle');

    if(this.$puzzle) {
      this.$dropzone = this.$puzzle.querySelector('.js-puzzle-dropzone');
      this.$draggable = this.$puzzle.querySelector('.js-puzzle-draggable');

      this.audioContext = null;
      this.snapBuffer = null;
      this.init();
    }
  }

  init() {
    gsap.registerPlugin(Draggable);
    this.initDraggable();
  }

  preloadAudio() {
    const snapUrl = '//www.purplegreens.com/cdn/shop/t/4/assets/purple-greens-puzzle-snap.mp3?v=9579764940831544081701953060';
    this.loadAudio(snapUrl).then((buffer) => {
      this.snapBuffer = buffer;
    });
  }

  initAudioContext() {
    this.audioContext = new window.AudioContext();
  }

  // Load audio file as a buffer
  async loadAudio(url) {
    const response = await fetch(url);
    const audioData = await response.arrayBuffer();
    return await this.audioContext.decodeAudioData(audioData);
  }

  // Play the audio buffer
  playSnapSound() {
    const source = this.audioContext.createBufferSource();
    source.buffer = this.snapBuffer;
    source.connect(this.audioContext.destination);
    source.start(0);
  }

  initDraggable() {
    this.draggable = Draggable.create(this.$draggable, {
      type: 'x,y',
      edgeResistance: 0.65,
      bounds: window,
      zIndex: 1,
      zIndexBoost: false,
      onPress: () => {
        this.startX = this.draggable[0].x;
        this.startY = this.draggable[0].y;

        this.$draggable.classList.add('puzzle__draggable--dragging');

        if(!this.audioContext) {
          this.initAudioContext();
          this.preloadAudio();
        }
      },
      onRelease: () => {
        this.$draggable.classList.remove('puzzle__draggable--dragging');
      },
      onDrag: () => {

      },
      onDragEnd: () => {
        this.$draggable.classList.remove('puzzle__draggable--dragging');

        const puzzleRect = this.$puzzle.getBoundingClientRect();
        const dropzoneRect = this.$dropzone.getBoundingClientRect();
        const draggableRect = this.$draggable.getBoundingClientRect();

        const dropzoneX = dropzoneRect.left - puzzleRect.left;
        const dropzoneY = dropzoneRect.top - puzzleRect.top;

        const draggableX = draggableRect.left - puzzleRect.left;
        const draggableY = draggableRect.top - puzzleRect.top;

        const distanceX = dropzoneX - draggableX;
        const distanceY = dropzoneY - draggableY;
        const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

        if(distance <= (dropzoneRect.width * 0.5)) {
          this.$draggable.classList.add('puzzle__draggable--snapped');
          gsap.to(this.$draggable, {
            x: this.draggable[0].x + distanceX,
            y: this.draggable[0].y + distanceY,
            duration: 0.1,
            ease: 'power2.out',
            onComplete: () => {
              this.playSnapSound();
            }
          });
        }else{
          this.$draggable.classList.remove('puzzle__draggable--snapped');
        }
      }
    });

    // fix initial position
    gsap.to(this.$draggable, {
      x: 0,
      y: 0,
      duration: 0,
    });
  }
}

const puzzle = new Puzzle();
